<div class="container">
    <cmps-wait-status *ngIf="params.pendingData"></cmps-wait-status>
    <div
        class="insight-backdrop-overlay"
        (click)="popUpService.hide()"
        *ngIf="popUpVisible"
    ></div>
    <div class="row">
        <div
            *ngIf="params.noFound"
            class="col-12"
        >
            <h6 class="alert alert-warning text-center">
                No data was found for this parameters
            </h6>
        </div>
        <div
            *ngIf="params.invalidDate"
            class="col-12"
        >
            <h6 class="alert alert-warning text-center">
                Please check the entered date.
            </h6>
        </div>
        <div class="col-12">
            <label>Name:&nbsp;</label>
            <span class="f-s-75-2">{{ params.user?.userName }}</span>
            <button
                (click)="onSelectUser($event)"
                class="green btn-mini"
            >
                <cmps-icon svgIcon="pencil"></cmps-icon>
            </button>
        </div>

        <div class="mt-3 col-6">
            <div class="flex-form">
                <label
                    class="mr-3 mb-0 min-25"
                    id="date-label"
                >
                    {{ i18n._965_DATE | translate }}
                </label>

                <div class="input-group">
                    <input
                        class="form-control"
                        [(ngModel)]="params.date"
                        (ngModelChange)="onSelectDate()"
                        placeholder="mm-dd-yyyy"
                        aria-labelledby="date-label"
                        ngbDatepicker
                        [minDate]="minDate"
                        [maxDate]="maxDate"
                        #dp="ngbDatepicker"
                        id="date"
                    />
                    <div class="input-group-append">
                        <button
                            type="button"
                            class="btn btn-secondary cmps-cdk-py-0dot5"
                            aria-label="Toggle date picker"
                            [attr.aria-expanded]="dp.isOpen()"
                            (click)="dp.toggle()"
                        >
                            <cmps-icon
                                class="green"
                                svgIcon="calendar"
                            ></cmps-icon>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="mt-3 col-6">
            <div class="flex-form">
                <label
                    class="mr-3 mb-0 min-25"
                    id="dateRange-label"
                >
                    {{ i18n._709_DATE_RANGE | translate }}
                </label>
                <ng-select
                    aria-labelledby="dateRange-label"
                    [options]="dateRanges"
                    [(ngModel)]="params.dateRange"
                    [placeholder]="'Comparison Dates'"
                    (selected)="clearNotFound()"
                >
                </ng-select>
            </div>
        </div>

        <div class="mt-3 col-6">
            <div class="flex-form">
                <label
                    class="mr-3 mb-0 min-25"
                    id="role-label"
                >
                    {{ i18n._59_ROLE | translate }}
                </label>
                <ng-select
                    aria-labelledby="role-label"
                    [(ngModel)]="params.role"
                    [options]="roles"
                    (selected)="clearNotFound()"
                    [placeholder]="'&nbsp;'"
                >
                </ng-select>
            </div>
        </div>

        <div class="mt-3 col-12">
            <ng-multiselect
                [config]="{
                    placeholder: 'Search metrics',
                    max: 4,
                    editable: true
                }"
                (change)="onSelectMetrics($event)"
                [options]="metrics || []"
                [value]="params.metrics"
            >
            </ng-multiselect>
        </div>

        <div class="mt-3 col-12">
            <button
                class="btn btn-primary pull-right"
                [disabled]="generateReportDisabled"
                type="button"
                (click)="onGenerateReport()"
            >
                <cmps-icon svgIcon="file-document"></cmps-icon>
                Generate Report
            </button>
        </div>
    </div>
</div>
